export const APP_READY = 'wr-thank-you-ready';
